<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><img alt="" src="OEBPS/images/9780062045980_L03.png"/></p>
<p class="center"><span class="big">CARRY ME<br/><br/>LIKE WATER</span></p>
<p class="center"><img alt="" src="OEBPS/images/9780062045980_L04.png"/></p>
<p class="center"><strong><em><span class="big2">A Novel</span></em></strong><br/><br/><br/><br/><br/></p>
<p class="center"><strong><span class="big1">B</span><span class="big2">ENJAMIN</span> <span class="big1">A</span><span class="big2">LIRE</span> <span class="big1">S</span><span class="big2">ÁENZ</span></strong><br/><br/><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/9780062045980_L01.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062045980_epub_tp_r1.vue?356f966e